import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import descriptionStyle from "assets/jss/material-kit-pro-react/views/aboutUsSections/descriptionStyle.jsx";

function SectionDescription(props) {
  const { classes } = props;
  return (
    <div className={classNames(classes.aboutDescription)}>
      <GridContainer>
        <GridItem
          md={8}
          sm={8}
          className={classNames(classes.mrAuto, classes.mlAuto)}
        >
          <h2 className={classes.description, classes.textCenter}>
            INVESTMENTS SERVICES FOR INSTITUTIONAL INVESTORS
          </h2>
          <h3>Kinos has built a valuable network of relationships with Sovereign Wealth Funds, Global Pension Funds and Institutions.
These relationships are close and meaningful, built on a foundation of trust and mutual respect.</h3>
          <h5>We manage institutional assets for a broad range of clients - including insurance companies, pension funds, banks, charities and family offices. We are a leading global investment firm that delivers innovative portfolio management services to institutional and private investors.
For more than 15 years, we have focused on discovering new ways to add long-term value to our clients’ portfolios based on their unique objectives.
  </h5><h5>
We have built a global network ( Torus Network ) of outstanding investment advisors and an extensive research platform to support them.
With more than 700 partners  around the globe, including investment and research staff on four continents, we are constantly looking to discover best-in-class ideas for our clients’ portfolios.

</h5><h5>
We have partners globally including the Spain, Europe, EMEA, Latin American, Asia, as well as Beijing, London, Singapore and Sydney.
</h5><h5>
We select our colleagues with great attention to their potential to become a valuable member of a collegial, intelligent and hard-working team.
</h5><h5>
Our clients trust the experience, leadership, and integrity of our investment professionals. Working with some of the world’s most sophisticated institutional investors, we bring a deep knowledge of portfolio management best practices to the clients we serve.
</h5><h5>
Our commitment to independence helps to ensure that the advice we give our clients is solely based on what is best for their portfolios.
          </h5>
        </GridItem>
      </GridContainer>
    </div>
  );
}

export default withStyles(descriptionStyle)(SectionDescription);
